export default __webpack_public_path__ + "static/logo-atlassian-77718aff5f0af4d4070864cf9993198f.png";